import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {AppConfig} from '../../app.config';

@Injectable({
  providedIn: 'root'
})
export class LearningPathsService {
  constructor(private http: HttpClient, private api: AppConfig) {
  }

  getLearningPaths(organizationId, countryId, cityId,
                   visibility, search, page, perPage): Observable<any[]> {
    return this.http.get<any[]>(this.api.baseUrl + '/learningPaths/learningPaths?organizationId=' + organizationId.toString()
      + '&countryId=' + countryId + '&cityId=' + cityId.toString() + '&visibility=' + visibility
      + '&search=' + search + '&page=' + page + '&perPage=' + perPage, this.api.jsonTokenHeaders);
  }

  getLearningPath(id: number): Observable<any> {
    return this.http.get<any>(this.api.baseUrl + `/learningPaths/learningPath?id=${id}`, this.api.jsonTokenHeaders);
  }

  addLearningPath(data: any): Observable<any> {
    const formData: FormData = new FormData();
    for (const key in data) {
      if (data.hasOwnProperty(key) && data[ key ] !== null) {
        formData.append(key , data[ key ]);
      }
      if (data.hasOwnProperty(key) && data[ key ] === null) {
        formData.append(key , '');
      }
      if (data.hasOwnProperty('hideEvents')) {
        formData.delete('hideEvents');
        formData.append('hideEvents', data.hideEvents ? '1' : '0');
      }
    }
    if (data.hasOwnProperty('certificateAllowed')) {
      formData.set('certificateAllowed', data.certificateAllowed ? '1' : '0');
    }
    if (data.hasOwnProperty('certificateTemplateId')) {
      formData.set('certificateTemplateId', data.certificateTemplateId ?? '');
    }
    return this.http.post<any>(this.api.baseUrl + '/learningPaths/addLearningPath', formData, this.api.formDataHeaders);
  }

  deleteLearningPath(id: number): Observable<any> {
    return this.http.get<any>(this.api.baseUrl + `/learningPaths/deleteLearningPath?id=${id}`, this.api.jsonTokenHeaders);
  }

  deleteParticipant(participantId): Observable<any> {
    return this.http.get<any>(this.api.baseUrl +
      `/learningPathsParticipant/deleteLearningPathsParticipant?id=${participantId}`,
      this.api.jsonTokenHeaders);
  }

  rewardsUser(data) {
    return this.http.post<any>(this.api.baseUrl + '/learningPaths/rewardsUser', data, this.api.formDataHeaders);
  }

  skillUser(data) {
    return this.http.post<any>(this.api.baseUrl + '/learningPaths/skillUser', data, this.api.formDataHeaders);
  }
}
